import { createAction, props } from "@ngrx/store";
import { DatosPlanes } from "../../Models/datosPlanes";
import { Planes } from "../../Models/planes";

export const loadPlanes = createAction('loadPlanes', props<{ data: DatosPlanes }>());

export const updatePlanes = createAction('updatePlanes', props<{ lplans: Planes }>());

export const updateDatosPlanes = createAction('updateDatosPlanes', props<{ upDatos: DatosPlanes }>());